import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import LocationCityBase from './views/LocationCityBase.vue'
import Cart from './views/Cart.vue'
import Pizza from './views/Pizza.vue'
import Product from './views/Product.vue'
import AboutUs from './views/AboutUs.vue'
import Offer from './views/Offer.vue'
import Application from './views/Application.vue'
import Cooperation from './views/Cooperation.vue'
import DeliveryMap from "@/views/DeliveryMap.vue";
import WhoPays from './views/WhoPays.vue'
import QrMenu from "@/views/QrMenu.vue";
import Check from "@/views/Check.vue";
import Menu from "@/views/Menu.vue";
import { V2_FEATURES } from '@/v2features'
import SEO from '../seo/pages.json'

Vue.use(Router)

// Новий дизайн (?v2): клас ставить public/index.html ще до старту Vue.
// Головна міста й сторінки категорій — одне меню одним гортанням (views/Menu.vue): той самий компонент
// на обох маршрутах, тож перехід між ними лише гортає до секції, без перемонтування
const V2 = document.documentElement.classList.contains('bp-v2');
const isMenuRoute = route => route.name == 'pizza' || route.name == 'category.index';

const router = new Router({
  scrollBehavior (to, from, savedPosition) {
    if (V2 && isMenuRoute(to) && isMenuRoute(from)) {
      return false;
    }
    return { x: 0, y: 0 }
  },
  // Демо-збірка (VUE_APP_DEMO=1, артефакт) живе під невідомим шляхом — там адреси сторінок у #/…
  mode: process.env.VUE_APP_DEMO ? 'hash' : 'history',
  // У демо BASE_URL — «./»; хеш-адресам основа не потрібна, а з «./» посилання стали б «/./#/…»
  base: process.env.VUE_APP_DEMO ? '/' : process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      // QR-код на столиках: самостійне фест-меню зі своєю корзиною
      path: '/qr',
      name: 'qr-menu',
      component: QrMenu
    },
    {
      // Сторінка чека за QR з кухонного чека: короткий і довгий синонім посилання
      path: '/c/:id/:sig',
      name: 'check',
      component: Check
    },
    {
      path: '/check/:id/:sig',
      component: Check
    },
    {
      // Без параметрів — лише кнопки сайт/додаток
      path: '/check',
      component: Check
    },
    {
      // Було lutsk+ — «+» у регулярному виразі відкривав і /lutskk, /lutskkk… як головну
      path: '/:locationCity(kyiv|lutsk)',
      component: LocationCityBase,
      children: [
        {
          path: '',
          name: 'pizza',
          component: V2 ? Menu : Pizza
        },
        {
          path: 'category/:code',
          name: 'category.index',
          component: V2 ? Menu : Product,
        },
        {
          path: 'cart',
          name: 'cart',
          component: Cart
        },
        {
          path: 'about-us',
          name: 'about-us',
          component: AboutUs
        },
        {
          path: 'delivery-map',
          name: 'delivery-map',
          component: DeliveryMap
        },
        {
          path: 'offer',
          name: 'offer',
          component: Offer
        },
        {
          path: 'application',
          name: 'application',
          component: Application
        },
        {
          // Новий дизайн: ігри «Хто платить?»; у старому дизайні сторінки немає, а поки ігри сховані (src/v2features.js) — на головну
          path: 'who-pays',
          name: 'who-pays',
          component: WhoPays,
          beforeEnter: (to, from, next) => V2 && V2_FEATURES.whoPays ? next() : next({ name: 'pizza', params: to.params })
        },
        {
          path: 'cooperation',
          name: 'cooperation',
          component: Cooperation,
          // Розділ закритий з 03.11 на прохання власника: пряме посилання веде на головну
          beforeEnter: (to, from, next) => next({ name: 'pizza', params: to.params })
        }
      ],
    },
  ]
})

// Заголовок вкладки, canonical і robots для кожної адреси — ті самі, що в статичних сторінках для ботів
// (seo/pages.json, seo/content.js). Опис не чіпаємо: його дає сама сторінка, з якої відкрили сайт
const DEFAULT_TITLE = document.title;
function headTag(selector, create, value) {
  let el = document.head.querySelector(selector);
  if (!value) { if (el) el.parentNode.removeChild(el); return; }
  if (!el) { el = create(); document.head.appendChild(el); }
  el.setAttribute(el.tagName == 'LINK' ? 'href' : 'content', value);
}
router.afterEach(to => {
  const key = to.name == 'category.index' ? 'category.index:' + to.params.code : to.name;
  const page = to.params.locationCity == SEO.city ? SEO.pages[key] : null;
  document.title = page ? page.title : DEFAULT_TITLE;
  headTag('link[rel="canonical"]', () => Object.assign(document.createElement('link'), { rel: 'canonical' }),
    page && !page.robots ? SEO.origin + page.path : null);
  headTag('meta[name="robots"]', () => Object.assign(document.createElement('meta'), { name: 'robots' }), page ? page.robots : null);
});

export default router
